module.exports = __webpack_public_path__ + "img/explain_rectangle_white.47f799f7.svg";